// =============================================================
// BUTTON — primary, signal, ghost, warm variants
// Mimari plan: solid renkler, AA kontrast
// =============================================================

import { type ReactNode, type ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

type Variant = "primary" | "signal" | "ghost" | "warm";
type Size = "md" | "lg";

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  type?: "button" | "submit" | "reset";
}

export function Button({
  children,
  variant = "primary",
  size = "md",
  className,
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn("btn", `btn--${variant}`, `btn--${size}`, className)}
      {...rest}
    >
      {children}
    </button>
  );
}

// Anchor variant — for tel:/mailto: links that look like buttons
interface LinkButtonProps {
  children: ReactNode;
  href: string;
  variant?: Variant;
  size?: Size;
  ariaLabel?: string;
  className?: string;
  prefetch?: boolean;
}

export function LinkButton({
  children,
  href,
  variant = "primary",
  size = "md",
  ariaLabel,
  className,
}: LinkButtonProps) {
  return (
    <a
      href={href}
      aria-label={ariaLabel}
      className={cn("btn", `btn--${variant}`, `btn--${size}`, className)}
    >
      {children}
    </a>
  );
}